<template>
	<div class="container__regra">
		<slot />
		<div
			v-if="edicaoHabilitada"
			class="container__regra__edicao"
		>
			<i
				v-if="mostrarOpcaoParaExcluirRegra"
				class="fas fa-times"
				@click="$emit('excluirRegra')"
			/>
			<i
				class="fas fa-check"
				@click="$emit('aplicarEdicao')"
			/>
		</div>
		<div
			v-else
			class="container__regra__habilita__edicao"
		>
			<i
				v-show="mostrarOpcaoParaEditarRegra"
				class="fas fa-edit"
				@click="$emit('habilitarEdicao')"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		edicaoHabilitada: {
			type: Boolean,
			required: true,
		},
		mostrarOpcaoParaExcluirRegra: {
			type: Boolean,
			default: true,
		},
		mostrarOpcaoParaEditarRegra: {
			type: Boolean,
			required: true,
		},
	},
}
</script>

<style scoped>
.container__regra {
	display: flex;
	border: solid 1px rgb(var(--color-primary));
	background-color: #f1f5f8;
	margin-top: 0.5rem;
	font-size: 0.875rem;
	padding: 0.25rem;
	align-items: center;
	gap: 0.5rem;
	border-radius: 5px;
	flex-wrap: wrap;
}

.container__regra__edicao i:nth-child(n + 2) {
	margin-left: 0.5rem;
}

.container__regra__edicao > .fa-times:hover {
	color: var(--color-error-background);
}

.container__regra__edicao > .fa-check:hover {
	color: rgb(var(--color-default));
}

div > i {
	cursor: pointer;
}

@media screen and (min-width: 992px) {
	.container__regra {
		width: max-content;
	}
}
</style>
